// UI translations for German (de), English (en), Danish (da)

const translations = {
  de: {
    nav: {
      home: "Start", about: "Über Uns", menu: "Speisekarte",
      gallery: "Galerie", sponsor: "Sponsor", contact: "Kontakt",
      reserve: "Reservieren", callNow: "Jetzt Anrufen"
    },
    hero: {
      namaste: "NAMASTE",
      callBtn: "Jetzt Anrufen",
      reserveBtn: "Tisch Reservieren",
      deliveryBtn: "Lieferservice",
      slides: [
        { title: "Willkommen bei PURI PURI", subtitle: "Traditionelle indische Küche in Flensburg" },
        { title: "Feinste indische Küche", subtitle: "Frisch, authentisch & mit Liebe zubereitet" },
        { title: "Unsere Räumlichkeiten", subtitle: "Liebevoll & traditionell eingerichtet" },
        { title: "Der wahre Geschmack Indiens", subtitle: "Vegetarisch, vegan, Lamm, Hähnchen & Fisch" }
      ]
    },
    about: {
      sub: "Namaste & Herzlich Willkommen",
      title: "Traditionelle indische Küche im Herzen von Flensburg",
      p1a: "Sie sind auf der Suche nach traditioneller indischer Küche in Flensburg und Umgebung? Dann sind Sie bei ",
      p1b: " genau richtig! Wir bieten Ihnen leckere hausgemachte indische Spezialitäten – vom klassischen Naan-Brot und aromatisch gewürzten Vorspeisen über herzhafte Lamm-, Rind- und Hähnchengerichte bis hin zu frisch zubereiteten Fisch-Spezialitäten.",
      p2: "Neben der klassischen indischen Küche haben wir uns auf vegane und vegetarische Speisen spezialisiert. Alle Gerichte können Sie wahlweise in normaler, mittlerer oder sehr scharfer Ausführung bestellen. Freuen Sie sich auf hausgemachte Desserts – vom indischen Karotten-Halwa bis zum Reis-Dessert mit Mandeln oder Mango.",
      f1: ["Vegetarisch &", "Vegan"],
      f2: ["Frisch aus", "dem Tandoor"],
      f3: ["Authentische", "Rezepte"],
      welcome: "„Wir heißen Sie herzlich willkommen im Restaurant Puri Puri und freuen uns auf Ihre Bestellung"
    },
    menu: {
      sub: "Unsere Karte", title: "Speisekarte",
      desc: "Eine kulinarische Reise durch Indien – von milden Kormas bis zu feurigen Vindaloos, alles frisch zubereitet mit den besten Gewürzen."
    },
    sponsor: {
      sub: "Stolzer Partner",
      titlePre: "Offizieller ", titleHi: "SC Weiche Flensburg", titlePost: " Sponsor",
      badge: "Offizieller Sponsor",
      headline: "Wir unterstützen mit Stolz den ", headlineHi: "lokalen Sport",
      desc: "PURI PURI ist stolzer Unterstützer und offizieller Sponsor des SC Weiche Flensburg von 1908. Als indisches Restaurant im Herzen von Flensburg engagieren wir uns aktiv für unsere Gemeinschaft und den lokalen Sport. Kultur, Miteinander und Leidenschaft – Werte, die uns verbinden.",
      values: ["Gemeinschaft", "Leidenschaft", "Tradition"]
    },
    gallery: {
      sub: "Impressionen", title: "Unsere Galerie",
      desc: "Liebevoll & traditionell eingerichtet – werfen Sie einen Blick in unser Restaurant und auf unsere Speisen."
    },
    contact: {
      sub: "Besuchen Sie Uns", title: "Kontakt & Anfahrt",
      address: "Adresse", phone: "Telefon", email: "E-Mail", hours: "Öffnungszeiten",
      route: "Route berechnen",
      phoneNote: "Wir freuen uns über Ihre Bestellung oder Reservierung.",
      callBtn: "Anrufen", reserveBtn: "Tisch Reservieren",
      days: [
        { day: "Montag", time: "17:00 – open end" },
        { day: "Dienstag – Sonntag", time: "12:00 – 14:00 & 17:00 – open end" }
      ]
    },
    footer: {
      contact: "Kontakt", hours: "Öffnungszeiten",
      tagline: "Der wahre Geschmack Indiens – traditionelle indische Küche im Herzen von Flensburg. Frisch, authentisch und mit Liebe zubereitet.",
      copyright: "Restaurant PURI PURI Flensburg · Der wahre Geschmack Indiens"
    },
    reserve: {
      sub: "Reservierung",
      title: "Ihren Tisch reservieren",
      or: "Oder rufen Sie uns direkt an: ",
      name: "Name", phone: "Telefon", email: "E-Mail", guests: "Gäste",
      date: "Datum", time: "Uhrzeit", note: "Nachricht (optional)",
      placeholder: "Allergien, besondere Wünsche...",
      submit: "Reservierung Absenden", callInstead: "Lieber Anrufen",
      toastTitle: "Reservierung eingegangen!",
      toastDescA: "Danke ", toastDescB: ". Wir bestätigen Ihre Reservierung am ", toastDescC: " um ", toastDescD: " Uhr in Kürze.",
      sending: "Wird gesendet...",
      errorTitle: "Fehler beim Senden",
      errorDesc: "Bitte versuchen Sie es erneut oder rufen Sie uns direkt an."
    },
    cookie: {
      title: "Datenschutz & Cookies",
      message: "Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Durch die Nutzung unserer Seite stimmen Sie unserer Datenschutzerklärung zu.",
      language: "Sprache wählen",
      accept: "Alle akzeptieren",
      customize: "Einstellungen",
      save: "Auswahl speichern",
      necessary: "Notwendig",
      necessaryDesc: "Für die Funktion der Website erforderlich (immer aktiv).",
      analytics: "Analyse",
      analyticsDesc: "Hilft uns zu verstehen, wie Besucher unsere Seite nutzen.",
      marketing: "Marketing",
      marketingDesc: "Wird für personalisierte Werbung verwendet."
    }
  },
  en: {
    nav: {
      home: "Home", about: "About", menu: "Menu",
      gallery: "Gallery", sponsor: "Sponsor", contact: "Contact",
      reserve: "Reserve", callNow: "Call Now"
    },
    hero: {
      namaste: "NAMASTE",
      callBtn: "Call Now",
      reserveBtn: "Reserve a Table",
      deliveryBtn: "Delivery",
      slides: [
        { title: "Welcome to PURI PURI", subtitle: "Traditional Indian cuisine in Flensburg" },
        { title: "Finest Indian Cuisine", subtitle: "Fresh, authentic & lovingly prepared" },
        { title: "Our Interior", subtitle: "Warmly & traditionally furnished" },
        { title: "The True Taste of India", subtitle: "Vegetarian, vegan, lamb, chicken & fish" }
      ]
    },
    about: {
      sub: "Namaste & A Warm Welcome",
      title: "Traditional Indian cuisine in the heart of Flensburg",
      p1a: "Looking for traditional Indian cuisine in Flensburg and the surrounding area? Then ",
      p1b: " is exactly the right place! We offer delicious homemade Indian specialties – from classic naan bread and aromatic starters to hearty lamb, beef and chicken dishes as well as freshly prepared fish specialties.",
      p2: "Alongside classic Indian cuisine, we specialize in vegan and vegetarian dishes. All dishes can be ordered mild, medium or very spicy. Enjoy homemade desserts – from Indian carrot halwa to rice dessert with almonds or mango.",
      f1: ["Vegetarian &", "Vegan"],
      f2: ["Fresh from", "the Tandoor"],
      f3: ["Authentic", "Recipes"],
      welcome: "\"We warmly welcome you to Restaurant Puri Puri and look forward to your order\""
    },
    menu: {
      sub: "Our Card", title: "Menu",
      desc: "A culinary journey through India – from mild kormas to fiery vindaloos, all freshly prepared with the finest spices."
    },
    sponsor: {
      sub: "Proud Partner",
      titlePre: "Official ", titleHi: "SC Weiche Flensburg", titlePost: " Sponsor",
      badge: "Official Sponsor",
      headline: "We proudly support ", headlineHi: "local sports",
      desc: "PURI PURI is a proud supporter and official sponsor of SC Weiche Flensburg von 1908. As an Indian restaurant in the heart of Flensburg, we actively engage with our community and local sports. Culture, togetherness and passion – values that connect us.",
      values: ["Community", "Passion", "Tradition"]
    },
    gallery: {
      sub: "Impressions", title: "Our Gallery",
      desc: "Warmly & traditionally furnished – take a look inside our restaurant and at our dishes."
    },
    contact: {
      sub: "Visit Us", title: "Contact & Directions",
      address: "Address", phone: "Phone", email: "E-Mail", hours: "Opening Hours",
      route: "Get Directions",
      phoneNote: "We look forward to your order or reservation.",
      callBtn: "Call", reserveBtn: "Reserve a Table",
      days: [
        { day: "Monday", time: "5:00 pm – open end" },
        { day: "Tuesday – Sunday", time: "12:00 – 2:00 pm & 5:00 pm – open end" }
      ]
    },
    footer: {
      contact: "Contact", hours: "Opening Hours",
      tagline: "The true taste of India – traditional Indian cuisine in the heart of Flensburg. Fresh, authentic and lovingly prepared.",
      copyright: "Restaurant PURI PURI Flensburg · The True Taste of India"
    },
    reserve: {
      sub: "Reservation",
      title: "Reserve your table",
      or: "Or call us directly: ",
      name: "Name", phone: "Phone", email: "E-Mail", guests: "Guests",
      date: "Date", time: "Time", note: "Message (optional)",
      placeholder: "Allergies, special requests...",
      submit: "Submit Reservation", callInstead: "Call Instead",
      toastTitle: "Reservation received!",
      toastDescA: "Thank you ", toastDescB: ". We will confirm your reservation on ", toastDescC: " at ", toastDescD: " shortly.",
      sending: "Sending...",
      errorTitle: "Error sending",
      errorDesc: "Please try again or call us directly."
    },
    cookie: {
      title: "Privacy & Cookies",
      message: "We use cookies to improve your experience on our website. By using our site, you agree to our privacy policy.",
      language: "Choose language",
      accept: "Accept all",
      customize: "Settings",
      save: "Save selection",
      necessary: "Necessary",
      necessaryDesc: "Required for the website to function (always active).",
      analytics: "Analytics",
      analyticsDesc: "Helps us understand how visitors use our site.",
      marketing: "Marketing",
      marketingDesc: "Used for personalized advertising."
    }
  },
  da: {
    nav: {
      home: "Forside", about: "Om Os", menu: "Menu",
      gallery: "Galleri", sponsor: "Sponsor", contact: "Kontakt",
      reserve: "Reservér", callNow: "Ring Nu"
    },
    hero: {
      namaste: "NAMASTE",
      callBtn: "Ring Nu",
      reserveBtn: "Reservér Bord",
      deliveryBtn: "Levering",
      slides: [
        { title: "Velkommen til PURI PURI", subtitle: "Traditionelt indisk køkken i Flensborg" },
        { title: "Fineste indiske køkken", subtitle: "Frisk, autentisk & kærligt tilberedt" },
        { title: "Vores lokaler", subtitle: "Kærligt & traditionelt indrettet" },
        { title: "Den ægte smag af Indien", subtitle: "Vegetarisk, vegansk, lam, kylling & fisk" }
      ]
    },
    about: {
      sub: "Namaste & Hjertelig Velkommen",
      title: "Traditionelt indisk køkken i hjertet af Flensborg",
      p1a: "Søger du efter traditionelt indisk køkken i Flensborg og omegn? Så er ",
      p1b: " lige stedet! Vi tilbyder lækre hjemmelavede indiske specialiteter – fra klassisk naan-brød og aromatisk krydrede forretter til kraftige lamme-, okse- og kyllingeretter samt friskt tilberedte fiskespecialiteter.",
      p2: "Ud over det klassiske indiske køkken har vi specialiseret os i veganske og vegetariske retter. Alle retter kan bestilles mild, mellem eller meget stærk. Glæd dig til hjemmelavede desserter – fra indisk gulerods-halwa til risdessert med mandler eller mango.",
      f1: ["Vegetarisk &", "Vegansk"],
      f2: ["Frisk fra", "tandooren"],
      f3: ["Autentiske", "opskrifter"],
      welcome: "„Vi byder dig hjerteligt velkommen på Restaurant Puri Puri og glæder os til din bestilling"
    },
    menu: {
      sub: "Vores Kort", title: "Menu",
      desc: "En kulinarisk rejse gennem Indien – fra milde kormaer til brændende vindaloos, alt friskt tilberedt med de bedste krydderier."
    },
    sponsor: {
      sub: "Stolt Partner",
      titlePre: "Officiel ", titleHi: "SC Weiche Flensburg", titlePost: " sponsor",
      badge: "Officiel Sponsor",
      headline: "Vi støtter med stolthed ", headlineHi: "den lokale sport",
      desc: "PURI PURI er stolt støtte og officiel sponsor af SC Weiche Flensburg von 1908. Som indisk restaurant i hjertet af Flensborg engagerer vi os aktivt i vores fællesskab og den lokale sport. Kultur, samhørighed og passion – værdier, der forbinder os.",
      values: ["Fællesskab", "Passion", "Tradition"]
    },
    gallery: {
      sub: "Indtryk", title: "Vores Galleri",
      desc: "Kærligt & traditionelt indrettet – tag et kig ind i vores restaurant og på vores retter."
    },
    contact: {
      sub: "Besøg Os", title: "Kontakt & Rute",
      address: "Adresse", phone: "Telefon", email: "E-mail", hours: "Åbningstider",
      route: "Beregn rute",
      phoneNote: "Vi glæder os over din bestilling eller reservation.",
      callBtn: "Ring", reserveBtn: "Reservér Bord",
      days: [
        { day: "Mandag", time: "17:00 – open end" },
        { day: "Tirsdag – Søndag", time: "12:00 – 14:00 & 17:00 – open end" }
      ]
    },
    footer: {
      contact: "Kontakt", hours: "Åbningstider",
      tagline: "Den ægte smag af Indien – traditionelt indisk køkken i hjertet af Flensborg. Frisk, autentisk og kærligt tilberedt.",
      copyright: "Restaurant PURI PURI Flensborg · Den ægte smag af Indien"
    },
    reserve: {
      sub: "Reservation",
      title: "Reservér dit bord",
      or: "Eller ring direkte: ",
      name: "Navn", phone: "Telefon", email: "E-mail", guests: "Gæster",
      date: "Dato", time: "Tidspunkt", note: "Besked (valgfri)",
      placeholder: "Allergier, særlige ønsker...",
      submit: "Send Reservation", callInstead: "Ring i stedet",
      toastTitle: "Reservation modtaget!",
      toastDescA: "Tak ", toastDescB: ". Vi bekræfter din reservation den ", toastDescC: " kl. ", toastDescD: " snarest.",
      sending: "Sender...",
      errorTitle: "Fejl ved afsendelse",
      errorDesc: "Prøv venligst igen eller ring til os direkte."
    },
    cookie: {
      title: "Privatliv & Cookies",
      message: "Vi bruger cookies for at forbedre din oplevelse på vores hjemmeside. Ved at bruge vores side accepterer du vores privatlivspolitik.",
      language: "Vælg sprog",
      accept: "Accepter alle",
      customize: "Indstillinger",
      save: "Gem valg",
      necessary: "Nødvendige",
      necessaryDesc: "Kræves for at hjemmesiden fungerer (altid aktive).",
      analytics: "Analyse",
      analyticsDesc: "Hjælper os med at forstå, hvordan besøgende bruger vores side.",
      marketing: "Marketing",
      marketingDesc: "Bruges til personlig annoncering."
    }
  }
};

// Category & item description translations keyed by original German
export const menuCategoryI18n = {
  Vorspeisen: { en: "Starters", da: "Forretter" },
  Suppen: { en: "Soups", da: "Supper" },
  Salate: { en: "Salads", da: "Salater" },
  "Spezialitäten mit Hähnchen": { en: "Chicken Specialties", da: "Kyllingeretter" },
  "Spezialitäten mit Lammfleisch": { en: "Lamb Specialties", da: "Lammeretter" },
  "Spezialitäten mit Rindfleisch": { en: "Beef Specialties", da: "Okseretter" },
  "Spezialitäten mit Fisch": { en: "Fish Specialties", da: "Fiskeretter" },
  Biryani: { en: "Biryani", da: "Biryani" },
  Vegetarisch: { en: "Vegetarian", da: "Vegetarisk" },
  Vegan: { en: "Vegan", da: "Vegansk" },
  Kindergerichte: { en: "Kids Menu", da: "Børnemenu" },
  Beilagen: { en: "Sides", da: "Tilbehør" },
  "Dips & Soßen": { en: "Dips & Sauces", da: "Dips & Saucer" }
};

export const menuSubtitleI18n = {
  "Aromatische Auftakt-Momente": { en: "Aromatic opening moments", da: "Aromatiske åbningsøjeblikke" },
  "Wärmend & aromatisch": { en: "Warming & aromatic", da: "Varmende & aromatisk" },
  "Frisch & knackig": { en: "Fresh & crisp", da: "Frisk & sprød" },
  "Zart & aromatisch": { en: "Tender & aromatic", da: "Mørt & aromatisk" },
  "Alle Gerichte werden mit Basmatireis serviert": { en: "All dishes served with basmati rice", da: "Alle retter serveres med basmatiris" },
  "Duftende Reisgerichte": { en: "Fragrant rice dishes", da: "Duftende risretter" },
  "Für unsere kleinen Gäste": { en: "For our little guests", da: "Til vores små gæster" },
  "Frisch aus dem Tandoor": { en: "Fresh from the tandoor", da: "Frisk fra tandooren" },
  "Perfekte Begleitung": { en: "The perfect pairing", da: "Det perfekte følgeskab" }
};

export default translations;
